import {
  getTaskGroups,
  getTaskGroupsPaginated,
} from '@dispatch/shared/services';
import { TaskGroupsListFilter } from '@dispatch/shared/types';
import { usePaginatedQuery } from '../api/usePaginatedQuery';
import { useQuery } from '../useQuery';

export const useGetTaskGroups = (enabled?: boolean) => {
  return useQuery(['task-groups'], () => getTaskGroups(), {
    enabled,
  });
};

export const useGetTaskGroupsPaginated = (
  filter: TaskGroupsListFilter,
  enabled = true
) => {
  return usePaginatedQuery(
    ['taskGroups', filter],
    (token) => getTaskGroupsPaginated(filter, token),
    {
      enabled,
    }
  );
};
